"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RemindersDropDown = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Clock = _interopRequireDefault(require("@react/react-spectrum/Icon/Clock"));

var _Menu = require("@react/react-spectrum/Menu");

var Constants = _interopRequireWildcard(require("../../constants/Constants"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

require("./RemindersDropDown.scss");

var _adobeIntlReact = require("@adobe/adobe-intl-react");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var RemindersDropDown =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RemindersDropDown, _Component);

  function RemindersDropDown() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RemindersDropDown);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RemindersDropDown)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      editReminderInProgress: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectionHandler", function (args) {
      switch (args) {
        case 'Remind5Min':
          _this.props.onReminderSelected(Constants.FIVE_MINUTES_IN_MILLISECONDS);

          _this.setState({
            closeMenu: true
          });

          break;

        case 'Remind15Min':
          _this.props.onReminderSelected(Constants.FIFTEEN_MINUTES_IN_MILLISECONDS);

          _this.setState({
            closeMenu: true
          });

          break;

        case 'Remind60Min':
          _this.props.onReminderSelected(Constants.SIXTY_MINUTES_IN_MILLISECONDS);

          _this.setState({
            closeMenu: true
          });

          break;

        case 'Remind24Hr':
          _this.props.onReminderSelected(Constants.TWENTY_FOUR_HOUR_IN_MILLISECONDS);

          _this.setState({
            closeMenu: true
          });

          break;

        case 'editReminder':
          _this.setState({
            editReminderInProgress: true,
            closeMenu: false
          });

          break;

        case 'deleteReminder':
          _this.setState({
            deleteReminder: true,
            closeMenu: true
          });

          _this.props.onReminderDeleted();

          break;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderReminderMenu", function () {
      return _react.default.createElement(_Menu.Menu, {
        className: "pulse-reminder-dropdown-menu",
        onSelect: function onSelect(args) {
          return _this.selectionHandler(args);
        }
      }, _react.default.createElement(_Menu.MenuItem, {
        value: "Remind5Min"
      }, _this.props.formatMessage({
        messageId: 'RemindMe5Min',
        defaultMessage: _this.props.localeData['en-US'].RemindMe5Min,
        description: "Remind me in 5 Minutes"
      })), _react.default.createElement(_Menu.MenuItem, {
        value: "Remind15Min"
      }, _this.props.formatMessage({
        messageId: 'RemindMe15Min',
        defaultMessage: _this.props.localeData['en-US'].RemindMe15Min,
        description: "Remind me in 15 Minutes"
      })), _react.default.createElement(_Menu.MenuItem, {
        value: "Remind60Min"
      }, _this.props.formatMessage({
        messageId: 'RemindMe60Min',
        defaultMessage: _this.props.localeData['en-US'].RemindMe60Min,
        description: "Remind me in an Hour"
      })), _react.default.createElement(_Menu.MenuItem, {
        value: "Remind24Hr"
      }, _this.props.formatMessage({
        messageId: 'RemindMeTomorrow',
        defaultMessage: _this.props.localeData['en-US'].RemindMeTomorrow,
        description: "Remind me tomorrow"
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderReminderEditMenu", function () {
      var reminderTime = _this.props.reminderTime;

      var formattedReminderTime = _PulseUtil.default.formatReminderTime(reminderTime);

      return _react.default.createElement(_Menu.Menu, {
        className: "pulse-reminder-dropdown-menu",
        onSelect: function onSelect(args) {
          return _this.selectionHandler(args);
        }
      }, _react.default.createElement(_Menu.MenuItem, {
        disabled: true
      }, _this.props.formatMessage({
        messageId: 'SetReminder',
        defaultMessage: "Reminder set for {formattedReminderTime}",
        values: {
          formattedReminderTime: formattedReminderTime
        },
        description: "Set Reminder"
      })), _react.default.createElement(_Menu.MenuItem, {
        value: "editReminder"
      }, _this.props.formatMessage({
        messageId: 'EditReminder',
        defaultMessage: _this.props.localeData['en-US'].EditReminder,
        description: "Edit Reminder"
      })), _react.default.createElement(_Menu.MenuItem, {
        value: "deleteReminder"
      }, _this.props.formatMessage({
        messageId: 'DeleteReminder',
        defaultMessage: _this.props.localeData['en-US'].DeleteReminder,
        description: "Delete Reminder"
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderReminder", function () {
      var editReminderInProgress = _this.state.editReminderInProgress;
      var isReminderActive = _this.props.isReminderActive;

      if (isReminderActive && !editReminderInProgress) {
        return _this.renderReminderEditMenu();
      }

      return _this.renderReminderMenu();
    });
    return _this;
  }

  (0, _createClass2.default)(RemindersDropDown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var closeMenu = this.state.closeMenu;
      var _this$props = this.props,
          isReminderActive = _this$props.isReminderActive,
          reminderTime = _this$props.reminderTime,
          formatMessage = _this$props.formatMessage,
          locale = _this$props.locale;

      var formattedReminderTime = _PulseUtil.default.formatReminderTime(reminderTime);

      return _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        delay: 100
      }, _react.default.createElement("div", {
        className: "pulse-notification-message-actions-button"
      }, _react.default.createElement(_OverlayTrigger.default, {
        trigger: "click",
        crossOffset: -100,
        placement: "bottom",
        disabled: closeMenu,
        onClick: function onClick(event) {
          event.stopPropagation();
          event.preventDefault();
        },
        onShow: function onShow() {
          return _this2.props.onReminderDropDownOpen();
        },
        onHide: function onHide() {
          return _this2.props.onReminderDropDownClose();
        }
      }, _react.default.createElement(_Button.default, {
        label: null,
        quiet: true,
        variant: "action",
        icon: _react.default.createElement(_Clock.default, {
          size: "S"
        }),
        className: "notification-snooze-button"
      }), this.renderReminder())), _react.default.createElement(_Tooltip.default, null, isReminderActive ? this.props.formatMessage({
        messageId: 'SetReminder',
        defaultMessage: "Reminder set for {formattedReminderTime}",
        values: {
          formattedReminderTime: formattedReminderTime
        },
        description: "Set Reminder"
      }) : this.props.formatMessage({
        messageId: 'Snooze',
        defaultMessage: this.props.localeData['en-US'].Snooze,
        description: "Snooze"
      })));
    }
  }]);
  return RemindersDropDown;
}(_react.Component);

exports.RemindersDropDown = RemindersDropDown;

var _default = (0, _adobeIntlReact.withLocalization)(RemindersDropDown);

exports.default = _default;